<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  font-family: "Microsoft YaHei", 微软雅黑, Arial, Verdana, Helvetica,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* color: rgb(105, 105, 105); */
  color: #666666;
  margin-top: 60px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue